import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import jsPDF from "jspdf";
import "jspdf-autotable";

const InvoicePDFDownloader = ({
    ticketData,
    invoiceData,
    subtotal,
    total,
    customerData,
    discount,
    PreBookDeduction
}) => {

    const downloadInvoicePDF = () => {
        const doc = new jsPDF();
        var img = new Image();
        img.src = "favicon.png";

        doc.addImage(img, 10, 5, 30, 30); // Slightly bigger + better placement

    // Move text BELOW the image
    let cursorY = 45;

        // Title
        doc.setFontSize(18);
        doc.text("Invoice", 14, cursorY);
        cursorY += 10;
        doc.setFontSize(12);
        doc.text(`Invoice Number: ${ticketData.invoice_id || "N/A"}`, 14, cursorY);
        cursorY += 7;
        doc.text(`Date: ${invoiceData.date}`, 14, cursorY);

        // From / To Section
        doc.text("From: Save Tax LLC", 14, cursorY + 10);
        const customerName = `${customerData.first_name} ${customerData.last_name}`;
        doc.text(`To: ${customerName}`, 14, cursorY + 17);

        // Table
        const tableColumn = ["Description", "Rate", "Qty", "Amount"];
        const tableRows = [];

        invoiceData.items.forEach((item) => {
            tableRows.push([
                item.description,
                `$${item.rate.toFixed(2)}`,
                item.quantity,
                `$${(item.rate * item.quantity).toFixed(2)}`
            ]);
        });

        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: cursorY + 25,
          theme: "grid",
          headStyles: {
            fillColor: [255, 71, 0], // <-- #ff4700
            textColor: [255, 255, 255],
            fontSize: 12,
            fontStyle: "bold",
          },
        });

        // Totals
        let finalY = doc.lastAutoTable.finalY + 10;

        doc.text(`Subtotal: $${subtotal.toFixed(2)}`, 14, finalY);
        finalY += 7;

        if (discount > 0) {
            doc.text(`Discount: $${discount.toFixed(2)}`, 14, finalY);
            finalY += 7;
        }

        if (ticketData.is_a_pre_book_ticket) {
            doc.text(`Pre-book Deduction: $${PreBookDeduction}`, 14, finalY);
            finalY += 7;
        }

        doc.text(`Total: $${total.toFixed(2)}`, 14, finalY);

        // Notes
        if (invoiceData.notes) {
            finalY += 10;
            doc.setFontSize(12);
            doc.text("Notes:", 14, finalY);
            finalY += 7;

            invoiceData.notes.split("\n").forEach((line) => {
                doc.text(line, 14, finalY);
                finalY += 7;
            });
        }

        // Download
        doc.save(`invoice_${ticketData.invoice_id || "invoice"}.pdf`);
    };

    return (
        <Tooltip title="Download Invoice PDF">
            <IconButton onClick={downloadInvoicePDF}>
                <FileDownload />
            </IconButton>
        </Tooltip>
    );
};

export default InvoicePDFDownloader;
